import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// API
import * as API from '../../utils/api';

// Components
import ProfileHeader from './Profile/ProfileHeader';
import ProfileMaintainers from './Profile/ProfileMaintainers';
import ProfileChangeLog from './Profile/ChangeLog';
import ProfileShortChangeLog from './Profile/ShortChangeLog';
import ProfileActions from './Profile/ProfileActions';

class Profile extends Component {
   static propTypes = {
    profile: PropTypes.object,
    profileUsername: PropTypes.string
  }

  state = {
    profile: null
  }

  componentDidMount() {
    const { profile } = this.props
    profile ? this.setState({ profile }) : this.updateProfile()
  }

  updateProfile = () => {
    API.adminProfile(this.currentUser(), this.profileUsername())
    .then(profile => this.setState({ profile }))
  }

  currentUser = () => this.props.user

  profileUsername = () => this.props.profileUsername || this.props.profile.username

  toggleSuspension = () => this.isSuspended() ? this.activate : this.suspend

  isSuspended = () => this.state.profile && this.state.profile.suspended

  activate = () => {
    API.activateProfile(this.currentUser(), this.profileUsername())
    .then(response => {
      response.success ? this.updateProfile() : console.log("Could not activate profile")
    })
  }

  suspend = () => {
    API.suspendProfile(this.currentUser(), this.profileUsername())
    .then(response => {
      response.success ? this.updateProfile() : console.log("Could not suspend profile")
    })
  }

  makeFree = () => {
    API.giveFreeSubscription(this.currentUser(), this.profileUsername())
    .then(response => {
      response.success ? this.updateProfile() : console.log("Count not give free subscription")
    })
  }

  deleteProfile = () => {
    API.deleteProfile(this.currentUser(), this.profileUsername())
    .then(response => {
      response.success ? this.props.onDeleteClicked(this.profileUsername()): console.log("Could not delete profile")
    })
  }

  render() {
    const { profile } = this.state

    if (!profile) { return null }

    const {
      active_payment,
      first_name,
      free_subscription,
      last_name,
      maintainers,
      suspended,
      username,
      change_log_entries
    } = profile

    const { shortLog } = this.props

    return (
      <div className="admin-profile-card">
        <ProfileHeader
          first_name={first_name}
          last_name={last_name}
          username={username}
          active_payment={active_payment}
          free_subscription={free_subscription}
        />
        <ProfileActions
          username={username}
          suspended={suspended}
          toggleSuspension={this.toggleSuspension()}
          free_subscription={free_subscription}
          makeFree={this.makeFree}
          deleteProfile={this.deleteProfile}
        />
        <ProfileMaintainers maintainers={maintainers} />
        {
          shortLog
          ? <ProfileShortChangeLog entries={change_log_entries} username={username} />
          : <ProfileChangeLog entries={change_log_entries} />
        }
      </div>
    )
  }
}

// Connect to Redux to get current user
const mapStateToProps = state => ({ user: state.user })

export default connect(mapStateToProps)(Profile)



// WEBPACK FOOTER //
// ./src/components/Admin/Profile.js